export default {
    components: {
    },
    props: {
        showDataForm: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => null
        }
    },
    data () {
        return {
            labelCol: { span: 4 },
            wrapperCol: { span: 18 },
            loading: false,
        }
    },
    computed: {},
    mounted () {},
    methods: {
        close() {
            this.$emit('update:showDataForm', false)
        }
    }
}
